import ClientDocumentPage from '../../../shared/components/ClientDocumentPage.jsx'

const API_BASE = import.meta.env.VITE_BID_WORKUP_API_URL || '/api/bidworkup'

/**
 * The client's copy of a bid proposal, opened from the link we email them.
 *
 * Replaces an attached PDF. On 2026-08-19 the attached version was blocked by Microsoft 365 as
 * high-confidence phishing — the message carried a commercial document and, uniquely among our
 * client emails, no link at all for the recipient to check.
 */
export default function ClientProposal() {
  return (
    <ClientDocumentPage
      apiBase={API_BASE}
      path="client/proposal"
      heading="Bid Proposal"
      fallbackName="proposal.pdf"
      gone="This link is no longer valid. Please ask for a new one."
      renderMeta={(d) => d?.job_name || null}
    />
  )
}
